



























import { Component, Vue, Prop } from 'vue-property-decorator';
import MobileDiscountTooltip from '@/components/familyPortal/sessionCard/MobileDiscountTooltip.vue';
import discountStore from '@/store/modules/discounts';

/**
 * Vue component for displaying multi-participant discount badge.
 * @component
 */
@Component({
  components: {
    MobileDiscountTooltip,
  }
})
export default class MultiParticipantDiscountBadge extends Vue {
  /**
   * Indicates if the component is viewed on a mobile device.
   * @prop {boolean} isMobile
   */
  @Prop({ type: Boolean, required: true }) isMobile!: boolean;

  /**
   * Gets the discount description text from the discount store.
   * @returns {string} The discount description text.
   */
  get discountDescriptionText(): string {
    return discountStore.discountDescriptionText;
  }

  /**
   * Gets the multi-participant discount name from the discount store.
   * @returns {string} The multi-participant discount name.
   */
  get multiDiscountName(): string {
    return discountStore.multiParticipantDiscountData
      ? discountStore.multiParticipantDiscountData.name
      : '';
  }

  /**
   * Gets the tooltip description for the discount from the discount store.
   * @returns {string} The tooltip description.
   */
  get tooltipDescription(): string {
    return discountStore.multiParticipantDiscountData
      ? discountStore.multiParticipantDiscountData.description
      : '';
  }
}
